module.exports = __webpack_public_path__ + "img/BY.66465d43.svg";